import { useRef } from 'react';
import { ProductCard } from '@/components/catalog/ProductCard';
import { IconButton, SectionHeader } from '@/components/ui';
import { productCatalogId } from '@/lib/catalog';
import type { Producto } from '@/types';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ProductCarouselProps {
  title: string;
  subtitle?: string;
  products: Producto[];
  viewAllHref?: string;
  viewAllLabel?: string;
  className?: string;
}

export function ProductCarousel({
  title,
  subtitle,
  products,
  viewAllHref = '/catalogo',
  viewAllLabel = 'Ver todo',
  className,
}: ProductCarouselProps) {
  const ref = useRef<HTMLDivElement>(null);

  const scroll = (dir: 'left' | 'right') => {
    ref.current?.scrollBy({ left: dir === 'left' ? -300 : 300, behavior: 'smooth' });
  };

  if (products.length === 0) return null;

  return (
    <section className={cn('page-section', className)}>
      <div className="container-app">
        <div className="flex items-end justify-between gap-4">
          <SectionHeader
            title={title}
            subtitle={subtitle}
            action={{ label: viewAllLabel, to: viewAllHref }}
          />
          <div className="hidden shrink-0 gap-1 sm:flex">
            <IconButton onClick={() => scroll('left')} aria-label="Anterior">
              <ChevronLeft className="h-4 w-4" />
            </IconButton>
            <IconButton onClick={() => scroll('right')} aria-label="Siguiente">
              <ChevronRight className="h-4 w-4" />
            </IconButton>
          </div>
        </div>

        <div ref={ref} className="carousel-scroll -mx-1 mt-8 flex gap-4 overflow-x-auto px-1 pb-2">
          {products.map((p) => (
            <div key={productCatalogId(p)} className="w-[260px] shrink-0 sm:w-[280px]">
              <ProductCard product={p} className="h-full" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
